import { store } from "../../../..";
import { updateWebAutomation } from "../webAutomationSlice";

const initialPlaywrightCSharpSpecflowState = {
  testCases: [],
  automationType: "",
  automationPath: "",
  featureFiles: "",
  pageDOM: "",
  locators: {},
  pageClass: [],
  stepDefinition: [],
  projectData: {},
  currentStep: "",
  isLoading: false,
  error: null,
};

function getUpdatedPlaywrightCSharpSpecflowState(locationKey, key, value) {
  const state = store.getState();

  const currentAutomationPreferences = state["testAutomation"][locationKey]["webAutomation"]["playwrightCSharpSpecflow"];

  return { ...currentAutomationPreferences, [key]: value };
}

export const createPlaywrightCSharpSpecflow = (locationKey) => updateWebAutomation(locationKey, "playwrightCSharpSpecflow", initialPlaywrightCSharpSpecflowState);

export const setTestCasesState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "testCases", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setAutomationType = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "automationType", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setAutomationPath = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "automationPath", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setFeatureFiles = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "featureFiles", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setPageDOM = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "pageDOM", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setLocatorsState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "locators", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setPageClassState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "pageClass", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setStepDefinitionState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "stepDefinition", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setProjectDataState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "projectData", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setCurrentStepState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "currentStep", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setIsLoadingState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "isLoading", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const setErrorState = (locationKey, data) => {
  const updatedPlaywrightCSharpSpecflow = getUpdatedPlaywrightCSharpSpecflowState(locationKey, "error", data);

  return updateWebAutomation(locationKey, "playwrightCSharpSpecflow", updatedPlaywrightCSharpSpecflow);
}

export const resetPlaywrightCSharpSpecflow = (locationKey) => updateWebAutomation(locationKey, "playwrightCSharpSpecflow", initialPlaywrightCSharpSpecflowState);